import styled from "styled-components";

export const OptInOuterFrameDefaultBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: rgba(151, 71, 255, 1);
    background-image: 
        url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_circle_svg.toString()}),
        linear-gradient(transparent, ${props => props.theme.colors.backgroundMiddleDark});

    background-size: 178%;
    background-repeat: no-repeat, no-repeat;
    background-position-y: 44%;
    background-position-x: 47%;
`;
